import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';
import { Loader2 } from 'lucide-react';

export interface DeletePlayEventSeriesConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  seriesName: string;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
}

export function DeletePlayEventSeriesConfirmDialog({
  open,
  onOpenChange,
  seriesName,
  onConfirm,
  loading = false,
}: DeletePlayEventSeriesConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(next) => !loading && onOpenChange(next)}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete series?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p>
                This permanently deletes <strong className="text-foreground">{seriesName}</strong> and
                all scheduled sessions in the series. Court holds are released and calendar entries
                are removed. This action cannot be undone.
              </p>
              <p>Online payments already collected are not refunded automatically.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={loading}>
            Keep series
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            disabled={loading}
            onClick={() => void onConfirm()}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Deleting…
              </>
            ) : (
              'Delete series'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
